module.exports = __webpack_public_path__ + "static/media/importICloud1.2abf2b04.png";